import React from 'react';
export function QueVasALograrSection() {
  return <section className="relative w-full text-white" style={{
    backgroundImage: "url('https://res.cloudinary.com/dd0wtuekk/image/upload/v1771285256/sporty_night_background_rlhcor.jpg')",
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    padding: '60px 20px'
  }} data-id="element-139">
      {/* Dark overlay */}
      <div className="absolute inset-0" style={{
      background: 'rgba(0,0,0,0.65)'
    }} data-id="element-140" />

      <div className="relative z-10 max-w-[600px] mx-auto" data-id="element-141">
        <h2 className="font-extrabold text-center" style={{
        fontSize: '22px',
        marginBottom: '24px'
      }} data-id="element-142">
          ¿QUÉ VAS A LOGRAR?
        </h2>

        <p style={{
        marginBottom: '18px',
        lineHeight: 1.6,
        fontSize: '15px'
      }} className="font-[600]" data-id="element-143">
          ✔ Vas a notar cómo su rendimiento mejora del entrenamiento al
          partido… porque por fin va a poder mostrar en la cancha todo lo que
          practica en la semana.
        </p>

        <p style={{
        marginBottom: '18px',
        lineHeight: 1.6,
        fontSize: '15px'
      }} className="font-[600]" data-id="element-144">
          ✔ Tu hijo va a recuperar la confianza en sí mismo y va a volver a
          jugar con esa seguridad que hoy le está faltando.
        </p>

        <p style={{
        marginBottom: '18px',
        lineHeight: 1.6,
        fontSize: '15px'
      }} className="font-[600]" data-id="element-145">
          ✔ Vas a ver cómo cambia su mentalidad: deja de achicarse y empieza a
          jugar con actitud de líder.
        </p>

        <p style={{
        marginBottom: '18px',
        lineHeight: 1.6,
        fontSize: '15px'
      }} className="font-[600]" data-id="element-146">
          ✔ Su entrenador va a empezar a notar el cambio: más seguridad, más
          carácter, más presencia en la cancha. Más mentalidad de campeón.
        </p>

        <p style={{
        marginBottom: '18px',
        lineHeight: 1.6,
        fontSize: '15px'
      }} className="font-[600]" data-id="element-147"></p>

        <p style={{
        lineHeight: 1.6,
        fontSize: '15px'
      }} className="font-[600]" data-id="element-148">
          ✔ Va a desarrollar constancia, enfoque y disciplina, hábitos mentales
          que no solo lo van a ayudar en el fútbol… sino en toda su vida.
        </p>
      </div>
    </section>;
}